import { AutoComplete, ISelectType, useFormContext } from "@4uhub/lib4uhub";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MainApi from "../../../../../../../services/mainApi.service";
import { TFileIntegrationForm } from "../../fileIntegrationSchema";

const translationPath = "page.4uBus.uBusAutomationRobot.";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/";
const genericService = new MainApi<ISelectType>(GENERIC_ROUTE);
export const RotationModeSelect = memo(() => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TFileIntegrationForm>();

  const rotateImages = useWatch({
    name: "rotateImages",
    control,
  });

  useEffect(() => {
    if (!rotateImages) {
      setValue("rotationMode", null);
    }
  }, [rotateImages, setValue]);

  return (
    <AutoComplete
      params={{ Identifier: "RotationMode" }}
      name="rotationMode"
      label={t(translationPath + "rotation_mode")}
      getOptionLabel={(option) => option.name}
      size="small"
      fullWidth
      request={genericService.list}
      disable={!rotateImages}
    />
  );
});
